import { DataService } from '../service/data.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CallBackEndService } from '../call-back-end.service';

@Component({
  selector: 'app-forgot-password-success',
  templateUrl: './forgot-password-success.component.html',
  styleUrls: ['./forgot-password-success.component.css'],
   providers: [DataService]
})
export class ForgotPasswordSuccessComponent implements OnInit {
returnUrl: string;
message:string;
  bankName: any;
  constructor(private route: ActivatedRoute,
      private fb: FormBuilder,
      private authenticationservice: DataService,
      public router: Router,webService : CallBackEndService ) {
        this.bankName = webService.getBankName();

       }
backHome()
  {
    this.router.navigate([this.returnUrl]); 
  }
  ngOnInit() {
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/index';
      this.message=sessionStorage.getItem('ForgotPwdScss');

  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/forgot-password-success/forgot-password-success.component.ts